export default {
  create: {
    success: 'Source(s) ajoutée(s) avec succès',
    error: "Impossible d'ajoutée(s) la/les source(s)"
  },
  delete: {
    success: 'Source(s) supprimée(s) avec succès',
    error: 'Impossible de supprimer la/les source(s)'
  }
}
